export const authBroadcastChannelName = 'gbs-auth-channel';

export enum authBroadcastChannelEvents {
  SignOut = 'signOut',
  NotifyForbidden = 'forbidden',
}

export const strongPasswordValidRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[_\W])(?!.*\s).{8,}$/;
